// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"451e798a","592":"0f1fe67e"}[chunkId] + ".chunk.js";
};